/* QubePro global feedback dialog */

.qp-feedback-overlay {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: color-mix(in srgb, var(--bg-primary) 42%, transparent);
  backdrop-filter: blur(3px);
}

.qp-feedback-dialog {
  --qp-feedback-danger-color: var(--action-danger);
  --qp-feedback-danger-border: color-mix(in srgb, var(--qp-feedback-danger-color) 36%, var(--border-color));
  --qp-feedback-danger-surface: var(--action-danger-bg);
  width: min(460px, 100%);
  max-height: calc(100vh - 48px);
  overflow: hidden;
  background: var(--card-bg);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  box-shadow: var(--shadow-lg);
  display: flex;
  flex-direction: column;
}

.qp-feedback-dialog__header {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 20px 22px 12px;
}

.qp-feedback-dialog__icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  color: var(--accent-primary);
  background: color-mix(in srgb, var(--accent-primary) 14%, transparent);
}

.qp-feedback-dialog--danger .qp-feedback-dialog__icon {
  color: var(--qp-feedback-danger-color);
  background: var(--bg-secondary);
  border: 1px solid var(--qp-feedback-danger-border);
}

.qp-feedback-dialog--warning .qp-feedback-dialog__icon {
  color: var(--status-draft);
  background: color-mix(in srgb, var(--status-draft) 14%, transparent);
}

.qp-feedback-dialog--success .qp-feedback-dialog__icon {
  color: var(--status-active);
  background: color-mix(in srgb, var(--status-active) 14%, transparent);
}

.qp-feedback-dialog__title-wrap {
  min-width: 0;
  flex: 1;
}

.qp-feedback-dialog__title {
  margin: 0;
  font-size: 18px;
  font-weight: 650;
  line-height: 1.35;
  color: var(--text-primary);
}

.qp-feedback-dialog__eyebrow {
  margin: 0 0 4px;
  font-size: 12px;
  font-weight: 650;
  color: var(--text-tertiary);
  text-transform: uppercase;
}

.qp-feedback-dialog__body {
  padding: 0 22px 20px 76px;
  overflow-y: auto;
}

.qp-feedback-dialog__message {
  margin: 0;
  color: var(--text-secondary);
  font-size: 14px;
  line-height: 1.55;
}

.qp-feedback-dialog__details {
  margin-top: 12px;
  padding: 10px 12px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--bg-secondary);
  color: var(--text-secondary);
  font-size: 13px;
  line-height: 1.45;
}

.qp-feedback-dialog__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 22px;
  border-top: 1px solid var(--border-color);
  background: var(--bg-secondary);
}

.qp-feedback-dialog__actions .btn-secondary,
.qp-feedback-dialog__actions .btn-primary,
.qp-feedback-dialog__actions .btn-danger {
  min-height: 38px;
  white-space: nowrap;
}

.qp-feedback-dialog__confirm-danger {
  background: var(--action-danger);
  color: var(--text-on-accent);
  border: 1px solid var(--action-danger);
  font-weight: 650;
}

.qp-feedback-dialog__confirm-danger:hover:not(:disabled) {
  background: var(--action-danger-hover);
  border-color: var(--action-danger-hover);
  color: var(--text-on-accent);
}

@media (max-width: 520px) {
  .qp-feedback-overlay {
    align-items: flex-end;
    padding: 12px;
  }

  .qp-feedback-dialog {
    width: 100%;
  }

  .qp-feedback-dialog__header {
    padding: 18px 18px 10px;
  }

  .qp-feedback-dialog__body {
    padding: 0 18px 18px;
  }

  .qp-feedback-dialog__actions {
    padding: 14px 18px 18px;
    flex-direction: column-reverse;
    align-items: stretch;
  }

  .qp-feedback-dialog__actions .btn-secondary,
  .qp-feedback-dialog__actions .btn-primary,
  .qp-feedback-dialog__actions .btn-danger {
    justify-content: center;
    width: 100%;
  }
}
